module.exports = __webpack_public_path__ + "static/steak-6-0b148d39ca5e9d3e87ff19ee50579ef9.png";